import createIcon from '../../createIcon';

/**
 * @component @name TvOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMSAzLjU0TDIuNTMgNS4wN0MxLjY1IDUuMjggMSA2LjA2IDEgN1YxOUMxIDIwLjEgMS45IDIxIDMgMjFIMTguNDZMMjAuNDYgMjNMMjEuNzIgMjEuNzNMMi4yNyAyLjI3TDEgMy41NFpNMyAxOVY3SDQuNDZMMTYuNDYgMTlIM1pNMjEgNUgxMy40MkwxNi43MSAxLjdMMTYgMUwxMiA1TDggMUw3LjMgMS43TDEwLjU4IDVINy41Mkw5LjUyIDdIMjFWMTguNDhMMjIuNjUgMjAuMTNDMjIuODcgMTkuODEgMjMgMTkuNDIgMjMgMTlWN0MyMyA1Ljg5IDIyLjExIDUgMjEgNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TvOff = createIcon('TvOff', [
  [
    'path',
    {
      d: 'M1 3.54L2.53 5.07C1.65 5.28 1 6.06 1 7V19C1 20.1 1.9 21 3 21H18.46L20.46 23L21.72 21.73L2.27 2.27L1 3.54ZM3 19V7H4.46L16.46 19H3ZM21 5H13.42L16.71 1.7L16 1L12 5L8 1L7.3 1.7L10.58 5H7.52L9.52 7H21V18.48L22.65 20.13C22.87 19.81 23 19.42 23 19V7C23 5.89 22.11 5 21 5Z',
      key: 'ctljbx',
    },
  ],
]);

export default TvOff;
